import {Locale} from '@hebcal/hdate';
import poData from './ashkenazi_romanian.po.js';
Locale.addLocale('ashkenazi_romanian', poData);
